
import PropTypes from 'prop-types'
import React from 'react'
import css from './index.module.css'
import Button from '../Button'
import StepIcon from '../icons/step'

const SetupTopbar = props => {
  return (
    <div className={css.main}>
      <h2 className={css.title}>{props.title}</h2>

      <div className={css.steps}>
        {props.steps.map((step, index) =>
          <div className={css.step} key={`__setup_top_bar_step_${index}`}>
            <StepIcon
              isComplete={step.isComplete}
              isActive={step.isActive}
              isError={step.isError} />

            <span className={css.stepLabel}>
              {step.label}
            </span>
          </div>
        )}
      </div>

      <Button
        href={props.buttonHref}
        onClick={props.buttonOnClick}
        modifier={props.buttonModifier || 'secondary'}
        wide>
        {props.buttonText}
      </Button>
    </div>
  )
}

SetupTopbar.propTypes = {
  buttonHref: PropTypes.string,
  buttonModifier: PropTypes.string,
  buttonOnClick: PropTypes.func,
  buttonText: PropTypes.string.isRequired,
  steps: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired
}

SetupTopbar.displayName = 'SetupTopbar'

export default SetupTopbar



// WEBPACK FOOTER //
// ./ui/SetupTopbar/index.js